import { XMLInterfaceObject } from "@goodgamestudios/core";
import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { ShopVO } from "./ShopVO";

export class GiftsVO extends ShopVO {
    //		public var timeleft:Number;
    public duration: number = NaN;

    constructor() {
        CONSTRUCTOR_HACK;
        super();
    }

    public getVisClassName(): string {
        return "Gift_" + this.itemCategory + "_" + this.id;
    }

    public fillFromParamXML(wodElement: XMLInterfaceObject): void {
        super.fillFromParamXML(wodElement);
        this.duration = parseInt((wodElement['duration'] || ''));
    }
}
classImplementsInterfaces(GiftsVO, "IInventoryVO");
